import React from 'react'
import ReactDOM from 'react-dom'
import './asset/styles/index.less'
import 'antd/dist/antd.less'
// import App from './application.js'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from '@/store'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import 'moment/locale/zh-cn'
import router from './router'
import { searchQuery } from '@/utils/common'

if (!window.name && window.self === window.top) {
  window.name = 'formRender'
}

const st = searchQuery(window.location.href, 'st')
store.dispatch({ type: 'setSameToken', data: st })

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <RouterProvider router={createBrowserRouter(router)} />
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
)
